import React from "react";
import PaymentOption from "./PaymentOption";

import PayCashIcon from "../../../../../assets/Images/cash-on-delivery.png";
import PayCardIcon from "../../../../../assets/Images/debit-card.png";

interface PaymentOptionsListProps {
  onSelect: (method: string) => void;
}

const PaymentOptionsList: React.FC<PaymentOptionsListProps> = ({ onSelect }) => {
  return (
    <div className="payment-options">
      <PaymentOption label="Card" image={PayCardIcon} alt="Pay with Card" onClick={() => onSelect("Card")} />
      <PaymentOption label="Cash" image={PayCashIcon} alt="Pay with Cash" onClick={() => onSelect("Cash")} />
    </div>
  );
};

export default PaymentOptionsList;
